import React from 'react';
import { CheckCircle } from 'lucide-react';
import { banners } from '@/lib/images';

const AboutSection = () => {
  return (
    <section id="about" className="py-16 md:py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            <span className="text-swastik-green font-medium">About Our Hospital</span>
            <h2 className="section-title">Healing with Nature's Wisdom Since 1960</h2>
            <p className="text-gray-600 mb-4">
              Shri Varaham Swastik Yoga & Naturopathy Hospital is a 4th generation center for Yoga and Naturopathy, Siddha and Varma, Ayurvedic and natural treatments, founded by Dr. P. Loganathan BNYS, a Yoga & Naturopathy Physician specialized in Chiropractic. He was inspired by his grandfather, Mr. Murugaiyan, who was renowned for his expertise in Varmam, Siddha, and Ayurveda. Our hospital continues a healing tradition that began in 1960, focusing on chronic diseases that modern medicine often struggles to cure permanently.
            </p>
            <p className="text-gray-600 mb-8">
              Combining ancient wisdom passed down through generations with modern scientific understanding, we provide holistic healing that treats the root cause of diseases, not just the symptoms. Our legacy is built on the dedication and knowledge of our forefathers, ensuring every patient receives care rooted in tradition and excellence.
            </p>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div className="flex items-start">
                <CheckCircle className="h-5 w-5 text-swastik-green mr-2 flex-shrink-0 mt-1" />
                <span className="text-gray-700">100% Natural Treatments</span>
              </div>
              <div className="flex items-start">
                <CheckCircle className="h-5 w-5 text-swastik-green mr-2 flex-shrink-0 mt-1" />
                <span className="text-gray-700">Certified Ayurvedic Physician</span>
              </div>
              <div className="flex items-start">
                <CheckCircle className="h-5 w-5 text-swastik-green mr-2 flex-shrink-0 mt-1" />
                <span className="text-gray-700">Personalized Treatment Plans</span>
              </div>
              <div className="flex items-start">
                <CheckCircle className="h-5 w-5 text-swastik-green mr-2 flex-shrink-0 mt-1" />
                <span className="text-gray-700">No Side Effects</span>
              </div>
              <div className="flex items-start">
                <CheckCircle className="h-5 w-5 text-swastik-green mr-2 flex-shrink-0 mt-1" />
                <span className="text-gray-700">Proven Results for Chronic Diseases</span>
              </div>
              <div className="flex items-start">
                <CheckCircle className="h-5 w-5 text-swastik-green mr-2 flex-shrink-0 mt-1" />
                <span className="text-gray-700">Modern Facilities & Accommodations</span>
              </div>
            </div>
          </div>
          
          <div className="relative">
            <div className="absolute -top-4 -left-4 w-32 h-32 md:w-48 md:h-48 bg-swastik-lightBlue/20 rounded-full z-0"></div>
            <div className="absolute -bottom-4 -right-4 w-32 h-32 md:w-48 md:h-48 bg-swastik-lightEarth rounded-full z-0"></div>
            
            <img
              src={banners.home}
              alt="Shri Varaham Swastik Yoga & Naturopathy Hospital healing garden"
              className="rounded-lg shadow-xl relative z-10 w-full h-auto object-cover"
            />
            
            <div className="bg-white rounded-lg shadow-lg p-4 absolute bottom-8 left-0 transform -translate-x-1/4 z-20 hidden md:block">
              <div className="flex items-center">
                <div className="bg-swastik-green rounded-full p-3">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                    <polyline points="9 22 9 12 15 12 15 22"></polyline>
                  </svg>
                </div>
                <div className="ml-3">
                  <p className="text-gray-600 text-sm">Established In</p>
                  <p className="font-bold text-gray-900">1960</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
